<ridango-block-full-width [isEmpty]="isEmpty">
    <span class="step" role="text" attr.aria-label="{{ 'BLOCK_STEP_ARIA_LABEL' | translate }} {{ step }}">{{
        step
    }}</span>
    <p
        class="block-full-width__title"
        *ngIf="!isEmpty && validityType && validityType !== validityTypeEnum.userSelectedStartDate && !isJointTicket">
        {{ 'VALIDITY' | translate }}
    </p>
    <h2
        class="block-full-width__title"
        *ngIf="isEmpty || !validityType || (validityType === validityTypeEnum.userSelectedStartDate && !isJointTicket)">
        {{ 'CHOOSE_STARTING_TIME' | translate }}
    </h2>

    <!-- Ticket activated on first validation -->
    <p
        class="block-full-width__description"
        *ngIf="!isEmpty && validityType === validityTypeEnum.activatedOnFirstValidation && !isJointTicket">
        {{ 'TICKET_ACTIVATED_ON_FIRST_VALIDATION' | translate }}
    </p>

    <!-- Ticket activated on purchase -->
    <p
        class="block-full-width__description"
        *ngIf="!isEmpty && validityType === validityTypeEnum.activatedAtPurchase && !isJointTicket">
        {{ 'TICKET_SUMMARY_V2_VALID_FROM_PURCHASE' | translate }}
    </p>

    <!-- Ticket activated on purchase dates -->
    <p
        class="block-full-width__description"
        *ngIf="!isEmpty && validityType === validityTypeEnum.productHasStartDate && !isJointTicket">
        {{ 'VALIDITY_DATES' | translate }}
    </p>
    <div
        class="validity-area"
        *ngIf="!isEmpty && validityType === validityTypeEnum.productHasStartDate && !isJointTicket">
        <div class="validity-dates">
            <div class="validity-dates__start">
                <span>{{ 'STARTS' | translate }}</span>
                <span class="date">{{ startDate | date: env.PRIMARY_DATE_FORMAT }}</span>
            </div>
            <div class="validity-dates__middle-line">
                <div class="line"></div>
            </div>
            <div class="validity-dates__end">
                <span>{{ 'ENDS' | translate }}</span>
                <span class="date">{{ endDate | date: env.PRIMARY_DATE_FORMAT }}</span>
            </div>
        </div>
    </div>

    <!-- Manual start date selection -->
    <div
        class="block-datepicker-area"
        *ngIf="!isEmpty && validityType === validityTypeEnum.userSelectedStartDate && !isJointTicket">
        <p class="block-datepicker-area__description">
            {{ 'CHOOSE_STARTING_TIME_DESCRIPTION' | translate }}
        </p>
        <div class="block-datepicker">
            <ridango-datepicker
                [date]="startDate"
                [maxDate]="maxDate"
                [minDate]="minDate"
                [yearsControl]="false"
                [lang]="locale"
                (dateUpdated)="startSelected($event)"></ridango-datepicker>
        </div>

        <p class="block-datepicker-area__validity-area" *ngIf="endDate">
            <span>{{ 'PURCHASE_DATE_SECTION_ENDING' | translate }}</span>
            {{ endDate | date: 'yyyy-MM-dd' }}
        </p>
    </div>

    <!-- Joint ticket -->
    <div *ngIf="!isEmpty && isJointTicket">
        <h2 class="block-full-width__title">{{ 'CHOOSE_TICKET_VALIDITY_PERIOD' | translate }}</h2>

        <p class="block-full-width__description">
            {{ 'JOINT_TICKET_MAX_LENGTH_DESC' | translate }}
        </p>

        <div class="date-selectors-row flex flex-col justify-center gap-4 sm:flex-row">
            <div class="starting-point">
                <div class="date-selector date-selector--labeled">
                    <ridango-datepicker
                        [label]="'LOCAL_LABEL_PERIOD_TICKET_START_DATE'"
                        [lang]="locale"
                        [date]="jointTicketStartDate"
                        [maxDate]="jointTicketMaxDate"
                        [minDate]="jointTicketMinDate"
                        [yearsControl]="false"
                        [dateFormat]="'dd.MM.yyyy'"
                        (dateUpdated)="onCustomStartDateChange($event)">
                    </ridango-datepicker>
                </div>
            </div>

            <div class="ending-point">
                <div class="date-selector date-selector--labeled">
                    <ridango-datepicker
                        [label]="'LOCAL_LABEL_PERIOD_TICKET_END_DATE'"
                        [lang]="locale"
                        [date]="jointTicketEndDate"
                        [maxDate]="jointTicketMaxEndDate"
                        [minDate]="jointTicketStartDate"
                        [yearsControl]="false"
                        [dateFormat]="'dd.MM.yyyy'"
                        (dateUpdated)="onCustomEndDateChange($event)">
                    </ridango-datepicker>
                </div>
            </div>
        </div>

        <p class="period-length pt-4 text-center">
            {{ 'PERIOD_TICKET_TEXT_SELECT_OWN_RANGE_DAYS_IN_PERIOD' | translate }}
            {{ jointTicketRangeTotalDays$ | async }}
            {{ 'PERIOD_TICKET_SELECT_RANGE_LENGTH_IS_DAYS' | translate }}
        </p>
    </div>
</ridango-block-full-width>
